/*
 * @Author: v_smwang
 * @Date: 2020-07-29 16:20:30
 * @LastEditors: v_smwang
 * @LastEditTime: 2020-07-29 16:22:17
 * @FilePath: \src\store\bootstrap.js
 * @Description: 描述
 * @Module: 模块路径
 */
import Vue from 'vue';
import store from '@/store/';
import { SIDEBAR_TYPE } from '@/store/mutation-types';
import CONFIG from '@/config';
import get from 'lodash/get';

export default function Initializer() {
  store.commit('SET_APP_TITLE', '公共系统平台');
  store.commit('SET_SIDEBAR_TYPE', Vue.ls.get(SIDEBAR_TYPE, true));
  store.commit('TOGGLE_THEME', get(CONFIG, 'Theme.navTheme'));
  store.commit('TOGGLE_LAYOUT_MODE', get(CONFIG, 'Theme.layout'));
  store.commit('TOGGLE_FIXED_HEADER', get(CONFIG, 'Theme.fixedHeader'));
  store.commit('TOGGLE_FIXED_SIDERBAR', get(CONFIG, 'Theme.fixSiderbar'));
  store.commit('TOGGLE_CONTENT_WIDTH', get(CONFIG, 'Theme.contentWidth'));
  store.commit('TOGGLE_FIXED_HEADER_HIDDEN', get(CONFIG, 'Theme.autoHideHeader'));
  store.commit('TOGGLE_WEAK', get(CONFIG, 'Theme.colorWeak'));
  store.commit('TOGGLE_COLOR', get(CONFIG, 'Theme.primary'));
  store.commit('TOGGLE_MULTI_TAB', get(CONFIG, 'Theme.multiTab'));

  // last step
}
